import React, { useState } from 'react'
import './About.css'
import { Link } from 'react-router-dom';
import {
    LazyLoadImage,
    LazyLoadComponent,
} from 'react-lazy-load-image-component';

// Assets

// Background video
const BannerBg = require('./videos/about-page-video.mp4');
const BannerBg_LazyLoadImg = require('./img/about-lazyload.png');

// Images
import aboutBg2 from './img/about-bg2.jpg'
import aboutBg3 from './img/about-bg3.jpg'
import teamBg1 from './img/team-bg.jpg'
import istvan from './img/leadership-istvan2.webp'
import tamas from './img/leadership-tamas2.webp'
import caroline from './img/leadership-caroline2.webp'
import skye from './img/leadership-skye.png'
import jesse from './img/leadership-jesse.png'
import linkedIN from './img/linkedin-r-dark-full-logo-black-and-white.png'

// Award logos
import award1 from './img/awards/35mules.png'
import award2 from './img/awards/growFL.png'
import award3 from './img/awards/VCIC.png'
import award4 from './img/awards/AAEA.png'
import award5 from './img/awards/EFL.png'
import award6 from './img/awards/GNV.png'

//Icons
import { TiArrowBack } from "react-icons/ti";

interface Leader {
    name: string;
    title: string;
    img: string;
    text: string;
    linkedin: string;
}

const About = () => {

    // Section for the video and its lazyLoad functionality
    const [isVideoLoaded, setIsVideoLoaded] = useState(false);
    const [selectedLeader, setSelectedLeader] = useState<Leader | null>(null);

    const leadershipData: Record<string, Leader> = {
        istvan: {
            name: "Dr. Istvan Kereszy",
            title: "Co-Founder, Chief Executive Officer",
            img: istvan,
            text: `Dr. Istvan Kereszy is the Co-Founder and Chief Executive Officer of FNN™, where he leads the company’s
        strategic direction and oversees the development of advanced AI technologies for wildfire detection,
        prevention, and utility resilience. A Fulbright Scholar and physicist, Dr. Kereszy earned his Ph.D.
        in Physics from the University of Florida, where he specialized in lightning research and its applications
        in environmental monitoring. His expertise in atmospheric science and data analysis serves as the foundation
        for FNN™’s innovation in transforming lightning data into actionable insights for mitigating wildfire and
        utility risk.`,
            linkedin: "https://www.linkedin.com/in/ikereszyfnn/",
        },
        tamas: {
            name: "Tamas Kereszy",
            title: "Co-Founder, Chief Operating Officer",
            img: tamas,
            text: `Tamas Kereszy is the Co-Founder and Chief Operating Officer of FNN™, where he oversees the company’s detector manufacturing and deployment operations. He brings extensive experience in engineering and operations, having previously served as a Technical Engineer at Procter & Gamble and as a Mechanical and Operations Engineer at Alchemr. Tamas holds a degree in Mechanical Engineering from the University of Florida and a Master’s degree in Business Management, combining technical expertise with strategic leadership to drive FNN™’s mission forward.`,
            linkedin: "https://www.linkedin.com/in/fnncoo/",
        },
        caroline: {
            name: "Caroline Comeau",
            title: "Co-Founder, Chief Commercial Officer",
            img: caroline,
            text: `Caroline Comeau is the Co-Founder and Chief Commercial Officer of FNN™, where she leads the company’s strategic growth, business development, and customer-facing initiatives. A NASDAQ Milestone Maker, she holds a degree in Economics from the University of Florida and an MBA from ESADE Business School. Caroline began her career in corporate finance and has since built extensive experience in business development and operations with Fortune 500 companies, including Ford Motor Company and CDW.`,
            linkedin: "https://www.linkedin.com/in/caroline-comeau-560sl/",
        },
        skye: {
            name: "Skye Perry",
            title: "Vice President, Utilities",
            img: skye,
            text: `Skye Perry is the Vice President, Utilities at FNN™, where he oversees utility partnerships and the integration of FNN™ technologies into critical infrastructure operations. A business technologist with extensive experience in GIS and utility software, Skye founded SSP Innovations in 2003 and has spent his career driving innovation in utilities, telecommunications, and pipeline management. He holds a BSBA in Decision & Information Sciences from the University of Florida and has applied his expertise as a software programmer, consultant, project manager, and entrepreneur.`,
            linkedin: "https://www.linkedin.com/in/skyeperry/",
        },
        jesse: {
            name: "Jesse Eisner",
            title: "Vice President, Strategy",
            img: jesse,
            text: `Jesse Eisner is the Vice President, Strategy at FNN™, where he leads corporate strategy, market development, and strategic initiatives to drive the company’s growth and impact. He brings extensive experience in energy trading, operations, and leadership, having served as COO and co-owner of Spotlight Energy, Executive Director of Spotlight Power, and Director of Gas Trading at Infinite Energy, Inc. Jesse holds a Bachelor’s degree in Business Administration from the University of Florida and previously served on the FNN™ Board, contributing his expertise in strategy, optimization, and business development.`,
            linkedin: "https://www.linkedin.com/in/jesse-eisner-71664820/",
        },
    };


    return (
        <div className="detector-container">

            {/* Cover Section */}
            <div className="detector-hero-section">
                {!isVideoLoaded && (
                    <LazyLoadComponent
                        placeholder={<img src={BannerBg_LazyLoadImg} alt="" />}
                    >
                        <LazyLoadImage
                            src={BannerBg_LazyLoadImg}
                            alt="="
                            className="hero-image"
                        />
                    </LazyLoadComponent>
                )}

                <video
                    className={`hero-image ${isVideoLoaded ? '' : 'hidden'}`}
                    src={BannerBg}
                    autoPlay
                    loop
                    muted
                    playsInline
                    onLoadedData={() => setIsVideoLoaded(true)}
                />

                <div className="dark-overlay"></div> {/* ← Overlay */}

                <div className="detector-info-wrapper">
                    <h1><strong> About Us</strong></h1>
                </div>
            </div>

            <h1 className='the-about-h1-title'>Our <span className='glow-blue'> Mission </span>
                is to Empower Customers to Stay Ahead of the Storm™</h1>

            <div className="youtube-about">
                <iframe
                    width="560"
                    height="315"
                    src="https://www.youtube-nocookie.com/embed/77wEToiX9oA"
                    title="FNN YouTube video player"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerPolicy="strict-origin-when-cross-origin"
                    allowFullScreen
                ></iframe>



                {/* <video className="video-diagram" controls>
              <source src={Video2} type="video/mp4" />
              Your browser does not support the video tag.
            </video> */}
            </div>

            <div className='redef-title-and-content tc-left-side'>
                <h1 className='the-redef-h1-title'>Redefining Lightning Detection</h1>

                <div className="redef-section">
                    <div className='redef-info-wrapper'>


                        <h2 className='the-h2'>At FNN™, we’re transforming the world’s understanding of lightning—one life-saving
                            insight at a time. Our patented High-Risk-Lightning™ (HRL™) detectors go beyond conventional approaches, 
                            identifying the most dangerous strikes: those with lasting currents and extreme energy capable of
                            sparking wildfires, crippling infrastructure, and cutting off power when it’s needed most.
                            By zeroing in on what truly matters, we empower our customers, emergency responders and
                            utilities, with the precision and foresight to <span className='glow-blue'> act</span> faster,
                            <span className='glow-blue'> protect</span> more, and <span className='glow-blue'>build </span> a
                            safer, more resilient world.</h2>
                    </div>

                    <img className="redef-image" alt="redef background" src={aboutBg2} />
                </div>
            </div>

            <div className='redef-title-and-content tc-right-side'>
                <h1 className='the-redef-h1-title redef-t-right-side'>Intelligence That Goes Beyond the Strike</h1>

                <div className="redef-section">
                    <img className="redef-image redef-image2" alt="redef background" src={aboutBg3} />

                    <div className='redef-info-wrapper'>
                        <h2 className='the-h2'>
                            It’s our team’s relentless curiosity and deep expertise that power
                            our cutting-edge technology. We’ve developed advanced detectors that use <span className='glow-blue'>AI </span> to 
                            decode lightning’s electric fingerprint, producing <span className='glow-blue'>real-time</span> 3D maps
                            with unprecedented accuracy. Our system delivers a clear, ground-level view of
                            conditions as they unfold—giving communities, industries, and emergency responders
                            the tools to anticipate threats before they strike. It’s not just technology—it’s
                            our team’s mission to protect what matters most.
                        </h2>
                    </div>
                </div>
            </div>

            <h1 className='the-about-h1-title vision'>Our <span className='glow-blue'> Vision </span>
                is to Build Technology That Saves Lives, Protects Property, and Increases Operational Efficiency</h1>

            <div className="high-risk-section">
                <div className='high-risk-info-wrapper small-padding'>
                    <h1 className='the-redef-h1-title no-margin-tt' style={{ color: '#28aae1' }}>FNN™ Leadership</h1>
                </div>

                <div className='about-us-leadership'>
                    {Object.entries(leadershipData).map(([key, person]) => (
                        <div
                            key={key}
                            className='leadership-person'
                            onClick={() => setSelectedLeader(person)}
                        >
                            <img
                                src={person.img}
                                alt={person.name}
                                className={person.name.includes("Jesse") ? "leader-img-contain" : "leader-img-cover"}
                            />
                            <strong>{person.name}</strong>
                            <p>{person.title}</p>
                        </div>
                    ))}
                </div>


            </div>

            {selectedLeader && (
                <div className='leadership-person-popup-overlay' onClick={() => setSelectedLeader(null)}>
                    <div className='leadership-person-popup-content' onClick={(e) => e.stopPropagation()}>
                        <div className='leadership-person-popup-image-and-text-section'>
                            <img
                                src={selectedLeader.img}
                                alt={selectedLeader.name}
                                className="popup-img-contain"
                            // className={
                            //     selectedLeader.name.includes("Istvan") || selectedLeader.name.includes("Tamas")
                            //         ? "popup-img-cover"
                            //         : selectedLeader.name.includes("Caroline")
                            //             ? "popup-img-cover-bottom"
                            //             : "popup-img-contain"
                            // }
                            />


                            <div className='leadership-person-popup-text-section'>
                                <p>{selectedLeader.text}</p>

                                <div className='leadership-person-popup-footer'>
                                    <a
                                        href={selectedLeader.linkedin}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        <img src={linkedIN} alt="LinkedIn" />
                                    </a>

                                    <button
                                        onClick={() => setSelectedLeader(null)}
                                        style={{ display: "flex", alignItems: 'center', gap: '0.3rem' }}
                                    >
                                        <TiArrowBack /> Back to Leadership
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}


            <div className="high-risk-section">
                <div className='high-risk-info-wrapper small-padding'>
                    <h1 className='the-redef-h1-title no-margin-tt' style={{ color: '#28aae1' }}>Proven. Trusted. Recognized.</h1>

                    <h2 className='the-h2 h2-adjust'>These honors celebrate the dedication, innovation, and resilience
                        of our team. From statewide recognition to national awards for entrepreneurship and
                        venture potential, each accolade reflects the collective effort behind our mission—and
                        the belief that together, we can build a safer, stronger future.</h2>

                </div>
            </div>

            <div className='award-image-wrapper'>

                <a
                    href="https://35mules.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="award-logos"
                >
                    <img alt="35 Mules" src={award1} />
                </a>

                <a
                    href="https://www.growfl.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="award-logos"
                >
                    <img alt="GrowFL" src={award2} />
                </a>

                <a
                    href="https://www.vcic.org/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="award-logos"
                >
                    <img alt="VCIC" src={award3} />
                </a>

                <a
                    href="https://aaeassociation.org/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="award-logos"
                >
                    <img alt="AAEA" src={award4} />
                </a>

                <a
                    href="https://endlessfrontierlabs.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="award-logos"
                >
                    <img alt="Endless Frontier Labs" src={award5} />
                </a>

                <a
                    href="https://www.gainesvillechamber.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="award-logos"
                >
                    <img alt="Greater Gainesville Chamber" src={award6} />
                </a>

            </div>

            <h1 className='the-about-h1-title' style={{ color: '#28aae1' }}>One Mission. One Team. One Future.</h1>

            <img className="team-pic" alt="redef background" src={teamBg1} />

            <h1 className='the-about-h1-title'>Every decision we make, every tool we build, is aimed at
                <span className='glow-blue'> creating a more resilient world</span>. At FNN™, we’re not  just
                imagining a safer tomorrow, we’re making it happen today, one strike at a time.</h1>

        </div>
    )
}

export default About